import { render, staticRenderFns } from "./ProfilePension.vue?vue&type=template&id=ef47da0a&"
import script from "./ProfilePension.vue?vue&type=script&lang=js&"
export * from "./ProfilePension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports